<template>
	<div>
		<template v-if="headerShow">
			<div class="cjfk">
			<div class="cjfkTil">
				{{$t('i18n_52')}}
			</div>
			<div class="cjfkBox">
				<div class="cjfkBoxFor" v-for="(item,index) in cjfkList" :key="index" @click="item.show=!item.show"
					:style="{
				height:item.show?'300px':'82px'
				}">
					<div class="cjfkBoxForTil">
						<div class="cjfkBoxForTilWz">{{item.question}}</div>
						<div class="cjfkBoxForTilIcon">
							<i class="el-icon-arrow-up" v-if="item.show"></i>
							<i class="el-icon-arrow-down" v-else></i>
						</div>
					</div>
					<div class="cjfkBoxForCen" v-if="item.show">
						{{item.answer}}
					</div>
				</div>
			</div>
		</div>
		</template>
		<template v-else>
			<div class="cjfk">
			<div class="cjfkTil">
				{{$t('i18n_52')}}
			</div>
			<div class="cjfkBox">
				<div class="cjfkBoxFor" v-for="(item,index) in cjfkList" :key="index" @click="item.show=!item.show"
					:style="{
				height:item.show?'300px':'82px'
				}">
					<div class="cjfkBoxForTil">
						<div class="cjfkBoxForTilWz">{{item.question}}</div>
						<div class="cjfkBoxForTilIcon">
							<i class="el-icon-arrow-up" v-if="item.show"></i>
							<i class="el-icon-arrow-down" v-else></i>
						</div>
					</div>
					<div class="cjfkBoxForCen" v-if="item.show">
						{{item.answer}}
					</div>
				</div>
			</div>
		</div>
		</template>
	</div>
</template>

<script>
	import {
		get_question
	} from '@/api/contact.js'
	export default {
		components: {

		},
		data() {
			return {
				cjfkList: []
			}
		},
		mounted() {
			// 常见优势
			this.getCjys();
		},
		methods: {
			getCjys() {
				let data = {}
				get_question(data).then(res => {
					console.log(res)
					let list = res.data.list;
					list.forEach(v => {
						v.show = false
					})
					this.$nextTick(function() {
						this.cjfkList = list
					})
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.cjfk {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;
		.cjfkTil {
			font-size: 36px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 57px;
		}

		.cjfkBox {
			display: flex;
			flex-wrap: wrap;

			.cjfkBoxFor:nth-of-type(2n) {
				margin-left: 2%;
			}

			.cjfkBoxFor {
				cursor: pointer;
				width: 49%;
				padding: 24px 38px;
				box-sizing: border-box;
				background-color: #f7f7f7;
				margin-bottom: 16px;
				border-radius: 10px;

				.cjfkBoxForTil {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.cjfkBoxForTil {
						font-size: 24px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #7E7E7E;
					}

					.cjfkBoxForTilIcon {
						font-size: 26px;
					}
				}

				.cjfkBoxForCen {
					margin-top: 31px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #666666;
					height: 180px;
					overflow-y: auto;
				}
			}
		}
	}


	@media screen and (max-width:1200px) {
		.cjfk{
			padding: 0 30px !important;
			box-sizing: border-box !important;
			width: 100% !important;
			.cjfkTil{
				font-size: 28px !important;
				width: 100% !important;
				margin-bottom: 30px !important;
			}
			.cjfkBox{
				width: 100% !important;
				display: block !important;
				.cjfkBoxFor{
					width: 100% !important;
					height:  auto !important;
					margin: 0 0 20px 0 !important;
				}
			}
		}
	}
</style>